import React from 'react';
import ReactTable from 'react-table'
import SweetAlert from 'sweetalert-react';
import 'sweetalert/dist/sweetalert.css';
import { renderToStaticMarkup } from 'react-dom/server';
import Select from 'react-select';






class SchedulesPage extends React.Component {

	constructor(props) {
	    super(props);
	    this.state = {
	    	show:false,
	    }
	    this.renderEditable = this.renderEditable.bind(this)
	}
	
	handleScheduleCellBlur = (cellInfo, event) => {
		const data = this.props.rows
		let value =  parseInt(event.target.value)
		isNaN(value) ? value = 0 : ''
		this.props.updateRowsInfo(cellInfo, value, this.props.type)
	}
	handleScheduleCellChange = (cellInfo, event) => {
		const data = this.props.rows
		let value =  parseInt(event.target.value)
		this.props.updateRowsInfo(cellInfo, value, this.props.type)
	}

	handleScheduleSelectCellChange = (cellInfo, event) => {
		const data = this.props.rows
		let value =  event.value
		this.props.updateRowsInfo(cellInfo, value, this.props.type)
	}
	

	renderSelect = (cellInfo) => {
	    return (
	      	<Select
                id='block_type'
                name="block_type"
                value={this.props.rows[cellInfo.index][cellInfo.column.id]}
                onChange={(e) =>{this.handleScheduleSelectCellChange(cellInfo, e)}}
                options={[
                  { value: 'break', label: 'Recreo' },
                  { value: 'class', label: 'Clases' },
                ]}
                placeholder="Seleccionar tipo de bloque"
             />
	    )
	 } 
	renderEditable(cellInfo) {
	    return (
	      <div>
	        <input 
	        	type="number"
	        	value={this.props.rows[cellInfo.index][cellInfo.column.id]}
				onBlur={(e) =>{this.handleScheduleCellBlur(cellInfo, e)}}
				onChange={(e) =>{this.handleScheduleCellChange(cellInfo, e)}}
				className="editable-cell"
	      	/>
	      </div>	
	    );
	 }

	cancelDeleteSchedule = () => {
	    this.setState({ show: false })
	}

	confirmDelete = () => {
	    this.setState({ show: true})
	}

	deleteSchedule = () => {
		this.setState({show: false}, this.props.deleteMethod())
	}

	render() {
		let data  = this.props.rows
		return (
			<div>
				 <SweetAlert
		          	show={this.state.show}
		          	title="Confirmar"
		          	text={renderToStaticMarkup(<h5>¿Eliminar el horario?</h5>)}
		          	html
		          	onConfirm={() => this.deleteSchedule()}
		          	onCancel = {() => this.cancelDeleteSchedule()}
		          	confirmButtonText= 'Eliminar'
		          	cancelButtonText= 'Cancelar'
		          	showCancelButton
		        />
				<div className="flex">
					<h3>Estructura Horario {this.props.type}</h3>
				</div>
				<div className='proportions-container'>
			        <ReactTable
			          data={this.props.rows}
			          resizeable={true}
			          columns={[
			            {
			              Header: "Numero de bloque",
			              accessor: "label",
			              maxWidth: 200,
			              className: 'proportion-cell'
			            },
			            {
			              Header: "Tipo",
			              accessor: "type",
			              maxWidth: 200,
			              className: 'proportion-cell',
			              Cell: this.renderSelect
			            },
			   			{
			              Header: "Minutos",
			              accessor: "minutes",
			              maxWidth: 200,
			              className: 'proportion-cell',
			              Cell: this.renderEditable
			            },
			          ]}
			          defaultPageSize={10}
			          className="-striped -highlight"
			        />

		      	</div>
		      	<div className="flex save-proportions-button-container">
			      	<div className=''>
				      	<button className='btn btn-primary' onClick={() => this.props.updateMethod()}>{this.props.isNew ? 'Crear' : 'Actualizar'}</button>
			      	</div>
			      	<div className='delete-button-proportions-page' style={this.props.isNew ? {display:'none'} : {display:'block'}}>
				      	<button className='btn btn-danger' onClick={() => this.confirmDelete()}>Eliminar</button>
			      	</div>
		      	</div>
		    </div>
      	)
	}

}

export default SchedulesPage


// WEBPACK FOOTER //
// ./src/components/schedules/SchedulesPage.js